import { useState } from "react";
import { Accordion, Icon } from "semantic-ui-react";
import { ICalculation } from "../../../models/calculation";

const formatBoolean = (opt: boolean) => {
    if (opt) return "Yes";
    else return "No";
};

const formatVrefOption = (val: number) => {
    switch (val) {
        case 0:
            return "RefProg";
        case 1:
            return "ZeroBalance";
        default:
            return "";
    }
};

interface IProps {
    calculation: ICalculation;
}

export const CalcPropsCCValidation = ({ calculation }: IProps) => {
    const [open, setOpen] = useState(false);

    return (
        <Accordion id="accordion-CalcPropsCCValidation-a">
            <Accordion.Title id="accordionTitle-CalcPropsCCValidation-a" active={open} index={0} onClick={() => setOpen(!open)}>
                <Icon id="icon-CalcPropsCCValidation-a" name="dropdown" />
                CC Validation
            </Accordion.Title>
            <Accordion.Content id="accordionContent-CalcPropsCCValidation-b" active={open}>
                <p id="p-CalcPropsCCValidation-b">
                    <label id="label-CalcPropsCCValidation-a">Observability area:&nbsp;</label>
                    {calculation.tsos!.join(", ")}
                </p>
                <p id="p-CalcPropsCCValidation-c">
                    <label id="label-CalcPropsCCValidation-c">VRefOption:&nbsp;</label>
                    {formatVrefOption(calculation.ccValidation!.vRefOption)}
                </p>
                <p id="p-CalcPropsCCValidation-d">
                    <label id="label-CalcPropsCCValidation-d">Absolute (MW):&nbsp;</label>
                    {calculation.ccValidation!.absolute}
                </p>
                <p id="p-CalcPropsCCValidation-e">
                    <label id="label-CalcPropsCCValidation-e">Relative (% of Vi):&nbsp;</label>
                    {calculation.ccValidation!.relative}
                </p>
                <p id="p-CalcPropsCCValidation-f">
                    <label id="label-CalcPropsCCValidation-f">Redispatching:&nbsp;</label>
                    {formatBoolean(calculation.ccValidation!.redispatching)}
                </p>
                <p id="p-CalcPropsCCValidation-g">
                    <label id="label-CalcPropsCCValidation-g">Returned branches:&nbsp;</label>
                    {formatBoolean(calculation.ccValidation!.returnedBranches)}
                </p>
                <p id="p-CalcPropsCCValidation-h">
                    <label id="label-CalcPropsCCValidation-h">Sensitivity threshold:&nbsp;</label>
                    {calculation.ccValidation!.sensitivityThreshold}
                </p>
                <p id="p-CalcPropsCCValidation-i">
                    <label id="label-CalcPropsCCValidation-i">Validation threshold:&nbsp;</label>
                    {calculation.ccValidation!.validationThreshold}
                </p>
                <p id="p-CalcPropsCCValidation-ii">
                    <label id="label-CalcPropsCCValidation-i">IVA Threshold:&nbsp;</label>
                    {calculation.ccValidation!.ivaThreshold}
                </p>
                <p id="p-CalcPropsCCValidation-iii">
                    <label id="label-CalcPropsCCValidation-i">Use Min Ram For IVA:&nbsp;</label>
                    {formatBoolean(calculation.ccValidation!.useMinRamForIva)}
                </p>
                <p id="p-CalcPropsCCValidation-iii">
                    <label id="label-CalcPropsCCValidation-i">IVA Min Ram Percentage:&nbsp;</label>
                    {calculation.ccValidation!.ivaMinRamPercentage}
                </p>
                <p id="p-CalcPropsCCValidation-j">
                    <label id="label-CalcPropsCCValidation-j">MNECs for optimization:&nbsp;</label>
                    {formatBoolean(calculation.ccValidation!.mnecsForOptimization)}
                </p>
                <p id="p-CalcPropsCCValidation-k">
                    <label id="label-CalcPropsCCValidation-k">Toggle loop flow:&nbsp;</label>
                    {formatBoolean(calculation.ccValidation!.toggleLoopFlow)}
                </p>
                <p id="p-CalcPropsCCValidation-l">
                    <label id="label-CalcPropsCCValidation-l">Loop flow threshold:&nbsp;</label>
                    {calculation.ccValidation!.loopFlowThreshold}
                </p>
                <p id="p-CalcPropsCCValidation-m">
                    <label id="label-CalcPropsCCValidation-m">Manual PSTs:&nbsp;</label>
                    {formatBoolean(calculation.ccValidation!.manualPSTs)}
                </p>
                <p id="p-CalcPropsCCValidation-rangeFromInitial">
                    <label id="label-CalcPropsCCValidation-rangeFromInitial">Range from initial:&nbsp;</label>
                    {formatBoolean(calculation.ccValidation!.rangeFromInitial)}
                </p>
                <p id="p-CalcPropsCCValidation-n">
                    <label id="label-CalcPropsCCValidation-n">Manual TopoRAs:&nbsp;</label>
                    {formatBoolean(calculation.ccValidation!.manualTopoRAs)}
                </p>
                <p id="p-CalcPropsCCValidation-o">
                    <label id="label-CalcPropsCCValidation-o">RCDC Fix:&nbsp;</label>
                    {formatBoolean(calculation.ccValidation!.rcdcFix)}
                </p>
                <p id="p-CalcPropsCCValidation-p">
                    <label id="label-CalcPropsCCValidation-p">MAX_RDR_UP [p.u]:&nbsp;</label>
                    {calculation.ccValidation!.maxRdrUp}
                </p>
                <p id="p-CalcPropsCCValidation-r">
                    <label id="label-CalcPropsCCValidation-r">MAX_RDR_DOWN [p.u]:&nbsp;</label>
                    {calculation.ccValidation!.maxRdrDown}
                </p>
                <p id="p-CalcPropsCCValidation-s">
                    <label id="label-CalcPropsCCValidation-s">All RD Switchable:&nbsp;</label>
                    {formatBoolean(calculation.ccValidation!.allRdSwitchable)}
                </p>
            </Accordion.Content>
        </Accordion>
    );
};
